import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import Layout from './Layout';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  cyberOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  adminOnly = false,
  cyberOnly = false
}) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const { isAuthenticated: isClientAuthenticated, user: clientUser } = useSelector((state: RootState) => state.clientAuth);

  // Pour cyberOnly, vérifier aussi dans clientAuth (pour PWA)
  if (cyberOnly) {
    // Vérifier si connecté via auth classique (cyber)
    if (isAuthenticated && user?.role === 'cyber') {
      return <Layout>{children}</Layout>;
    }

    // Vérifier si connecté via clientAuth avec user_type=cyber
    if (isClientAuthenticated && clientUser && ((clientUser as any).user_type === 'cyber' || (clientUser as any).role === 'cyber')) {
      // Afficher avec Layout pour permettre la navigation et la déconnexion
      return <Layout>{children}</Layout>;
    }

    // Sinon rediriger vers login client
    return <Navigate to="/client/login" />;
  }

  // Pour les autres routes, vérifier auth classique OU clientAuth (pour cybers connectés via /client/login)
  const isCyberViaClientAuth = isClientAuthenticated && clientUser &&
    ((clientUser as any).user_type === 'cyber' || (clientUser as any).role === 'cyber');

  if (!isAuthenticated && !isCyberViaClientAuth) {
    return <Navigate to="/login" />;
  }

  // Vérifier le rôle si nécessaire
  if (adminOnly) {
    const userRole = user?.role || (clientUser as any)?.role;
    if (userRole !== 'admin') {
      return <Navigate to="/cyber-dashboard" />;
    }
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;
